import constants from './../../constants';

// The plates to load on one side of the bar, heaviest first, adding up to weightOnSide.
//
// It takes the heaviest plate that fits, and steps back to a lighter one when the heaviest
// would leave a remainder no plate can make. With 1.5 lb left, 1.25 would strand 0.25, so
// it loads 1 and 0.5 instead. Wherever heaviest-first already adds up, the result is the
// same plates it always was.
//
// Weights are counted in quarter pounds so the sums are exact. When no set of plates adds
// up to the weight (45.5 lb on a 45 lb bar needs 0.25 a side), it returns the heaviest
// load below it.
export default function platesForSide(weightOnSide, plates = constants.PLATES_WEIGHTS) {
  const sizes = [...plates].sort((a, b) => b - a);
  const quarters = sizes.map(plate => Math.round(plate * 4));
  const wanted = Math.floor(Number(weightOnSide) * 4 + 1e-9);

  if (!(wanted > 0)) {
    return [];
  }

  const cannotFill = new Set();

  const fill = (remaining, from) => {
    if (remaining === 0) {
      return [];
    }

    const key = remaining * quarters.length + from;
    if (cannotFill.has(key)) {
      return null;
    }

    for (let i = from; i < quarters.length; i += 1) {
      if (quarters[i] <= remaining) {
        const rest = fill(remaining - quarters[i], i);
        if (rest) {
          return [sizes[i], ...rest];
        }
      }
    }

    cannotFill.add(key);
    return null;
  };

  for (let target = wanted; target > 0; target -= 1) {
    const found = fill(target, 0);
    if (found) {
      return found;
    }
  }

  return [];
}
